import {Component, inject, input, model, output} from '@angular/core';
import {Settings} from '../settings.interface';
import {UntypedFormBuilder} from '@angular/forms';
import {SettingsService} from '../settings.service';
import {UserService} from '@app/shared/_services/user.service';
import {notificationsSMTPValues} from '../settings.model';
import {TranslateService} from '@app/shared/_services/translate.service';
import {AuthenticationService} from '@app/shared/_services/authentication.service';
import {Router} from '@angular/router';
import { DrawerModule } from 'primeng/drawer';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { Button } from 'primeng/button';
import { TranslatePipe } from '../../../shared/_pipes/translate.pipe';

@Component({
    selector: 'settings-integrations-smtp',
    template: `
      <p-drawer [blockScroll]="true"  [baseZIndex]="100002" styleClass="p-drawer-lg" position="right" [(visible)]="visible" (onShow)="onShow()"
        (visibleChange)="onVisibleChange($event)">
        <ng-template pTemplate="header">
          <h3>{{'settings_smtp_slide_title' | i18n}}</h3>
        </ng-template>
        <div class="p-6">
          <p>{{'settings_smtp_slide_description' | i18n}}</p>
          <p>{{'settings_smtp_slide_description_api' | i18n}}</p>
          <p><a (click)="goToApiKeySettings()">{{'settings_apikeys_slide_add' | i18n}}</a></p>
          <div class="col-12 md:col-10 md:col-offset-1 mt-8">
            <p-table styleClass="p-datatable-striped p-datatable-gridlines p-datatable-responsive-stack"
              responsiveLayout="stack"
              [value]="notificationsSMTPValues">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'settings_smtp_slide_parameter' | i18n}}</th>
                  <th>{{'settings_smtp_slide_value' | i18n}}</th>
                <!--th></th-->
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-smtp>
              <tr>
                <td><span class="p-column-title">{{'settings_smtp_slide_parameter' | i18n}}</span><span [innerHTML]="smtp.parameter"></span></td>
                <td><span class="p-column-title">{{'settings_smtp_slide_value' | i18n}}</span><span [innerHTML]="smtp.value"></span></td>
                <!--td><span [innerHTML]="smtp.extra"></span></td-->
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="text-end p-drawer-toolbar-fixed">
        <p-button type="button" [label]="'button_close' | i18n" [outlined]="true"  styleClass="p-button-outlined p-button-secondary" (onClick)="onVisibleChange(false)"></p-button>
      </div>
    </p-drawer>
    `,
    imports: [DrawerModule, PrimeTemplate, TableModule, Button, TranslatePipe]
})
export class SettingsIntegrationsSidebarSMTPComponent{
  private formBuilder = inject(UntypedFormBuilder);
  private _settingsService = inject(SettingsService);
  private _userService = inject(UserService);
  private _translateService = inject(TranslateService);
  private authenticationService = inject(AuthenticationService);

  readonly visible = model<boolean>(false);

  readonly item = input<Settings.Tool>(undefined);
  readonly itemChange = output<Settings.Tool>();

  private router = inject(Router);
  notificationsSMTPValues: Settings.SMTPTBodyOption[];

  onShow() {
    const hostKey = this._userService.getInfoValue('is_european') ? 'settings_notifications_smtp_host_eu' :  'settings_notifications_smtp_host';
    this.notificationsSMTPValues = notificationsSMTPValues
      .filter(notificationsSMTPValue => {
        return notificationsSMTPValue.parameter !== 'settings_notifications_smtp_server' || (notificationsSMTPValue.parameter === 'settings_notifications_smtp_server' && notificationsSMTPValue.value === hostKey) ;
      })
      .map(notificationSMTPValue => {
      notificationSMTPValue.translateValue = 'translateValue' in notificationSMTPValue ? notificationSMTPValue.translateValue : true;
      notificationSMTPValue.translateExtra = 'translateExtra' in notificationSMTPValue ? notificationSMTPValue.translateExtra : true;
      notificationSMTPValue.translateParameter = 'translateParameter' in notificationSMTPValue ? notificationSMTPValue.translateParameter : true;

      if (notificationSMTPValue.translateValue) {
        notificationSMTPValue.value = this._translateService.translate(notificationSMTPValue.value);
      }

      if (notificationSMTPValue.translateExtra) {
        notificationSMTPValue.extra = this._translateService.translate(notificationSMTPValue.extra);
      }

      if (notificationSMTPValue.translateParameter) {
        notificationSMTPValue.parameter = this._translateService.translate(notificationSMTPValue.parameter);
      }
      /*
      if (notificationSMTPValue?.id === 'smtpuser') {
        notificationSMTPValue.value = this.authenticationService?.currentUserValue?.authemail;
      }
      */
      return notificationSMTPValue;
    });
  }

  onVisibleChange(visible: boolean) {
    this.visible.set(visible);
  }

  goToApiKeySettings() {
    this.visible.set(false);
    this.router.navigate(['/settings/integrations/apikeys']);
  }
}

